import styled from "styled-components";
import { IoArrowBackOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";

export const IconBack = styled(IoArrowBackOutline)`
  position: fixed;
  top: 50px;
  left: 50px;
  font-size: 50px;
  cursor: pointer;
  transition: 0.25s;
  z-index: 100000;

  &:hover {
    color: var(--blue-color);
    transform: translateX(-5px);
  }

  @media print {
    display: none;
  }
`;

export const IconDownload = styled(FiDownload)`
  position: fixed;
  top: 50px;
  right: 50px;
  font-size: 50px;
  cursor: pointer;
  transition: 0.25s;
  z-index: 100000;

  &:hover {
    color: var(--blue-color);
    transform: translateY(5px);
  }

  @media print {
    display: none;
  }
`;
